"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const native_1 = require("@react-navigation/native");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const styles_1 = __importDefault(require("../../styles/styles"));
const useWebDesktopDesign_1 = __importDefault(require("../../hooks/useWebDesktopDesign"));
const constants_1 = require("../../constants/constants");
const ticketSummary_1 = __importDefault(require("./ticketSummary"));
const ticketForm_1 = __importDefault(require("./ticketForm"));
const useAppSelector_1 = __importDefault(require("../../hooks/useAppSelector"));
const typesConstants_1 = require("../../constants/typesConstants");
const spinner_1 = __importDefault(require("../spinner/spinner"));
const useAppDispatch_1 = __importDefault(require("../../hooks/useAppDispatch"));
const ticketSlice_1 = require("../../features/ticket/ticketSlice");
const navBar_1 = __importDefault(require("../navBar/navBar"));
const boxTitle_1 = __importDefault(require("../boxTitle/boxTitle"));
const pressable_1 = __importDefault(require("../pressable/pressable"));
const screenConstants_1 = require("../../constants/screenConstants");
const eventConstants_1 = require("../../constants/eventConstants");
const icon_1 = __importDefault(require("../icon/icon"));
const commentsContainer_1 = __importDefault(require("./commentsContainer"));
const ticketConstants_1 = require("../../features/ticket/ticketConstants");
const tab_1 = __importDefault(require("../tab/tab"));
const TicketDetails = () => {
    let content = react_1.default.createElement(react_1.default.Fragment, null);
    const dispatch = useAppDispatch_1.default();
    const navigator = native_1.useNavigation();
    const route = native_1.useRoute();
    const ticketID = route.params && route.params.ticket_id;
    const isDesktop = useWebDesktopDesign_1.default(constants_1.DESKTOP_BREAKPOINT);
    const containerStyle = isDesktop ? styles_1.default.allScreenWeb : styles_1.default.allScreenMobile;
    const { loadingStatus, selectedTicket, selectedTicketComments } = useAppSelector_1.default((state) => ({
        loadingStatus: state.ticket.loadingStatus,
        selectedTicket: state.ticket.selectedTicket,
        selectedTicketComments: state.ticket.selectedTicketComments,
    }));
    const [activeTab, setActiveTab] = react_1.useState(ticketConstants_1.DETAIL_TAB);
    react_1.useEffect(() => {
        dispatch(ticketSlice_1.getTicket({ ticket_id: ticketID }));
        dispatch(ticketSlice_1.getComments({ ticket_id: ticketID }));
    }, [ticketID]);
    const handleTicketUpdate = () => {
        setActiveTab(ticketConstants_1.UPDATE_TAB);
    };
    if (loadingStatus === typesConstants_1.PENDING_STATUS) {
        content = react_1.default.createElement(spinner_1.default, null);
    }
    else if (selectedTicket && activeTab === ticketConstants_1.DETAIL_TAB) {
        content = (react_1.default.createElement(react_native_1.View, null,
            react_1.default.createElement(ticketSummary_1.default, { ticket: selectedTicket }),
            react_1.default.createElement(commentsContainer_1.default, { ticket: selectedTicket, comments: selectedTicketComments })));
    }
    else if (selectedTicket && activeTab === ticketConstants_1.UPDATE_TAB) {
        content = (react_1.default.createElement(react_native_1.View, { style: [isDesktop && styles_1.default.flexDirectionRow, styles_1.default.centeredView] },
            react_1.default.createElement(ticketForm_1.default, { ticket: selectedTicket })));
    }
    return (react_1.default.createElement(navBar_1.default, null,
        react_1.default.createElement(react_native_1.View, { style: [containerStyle, styles_1.default.marginBottomTwenty] },
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexDirectionRow },
                react_1.default.createElement(react_native_1.View, { style: [styles_1.default.alignCenterStart, styles_1.default.marginTen] },
                    react_1.default.createElement(boxTitle_1.default, { title: "Ticket Detail" })),
                react_1.default.createElement(react_native_1.View, { style: [styles_1.default.alignCenterEnd, styles_1.default.flexOne] },
                    react_1.default.createElement(react_native_1.View, null,
                        react_1.default.createElement(pressable_1.default, { onPress: () => navigator.navigate(screenConstants_1.TICKET_SCREEN), style: [styles_1.default.flexDirectionRow, styles_1.default.alignCenterCenter], eventName: eventConstants_1.NAVIGATE_HOME_BUTTON },
                            react_1.default.createElement(react_native_1.View, null,
                                react_1.default.createElement(icon_1.default, { icon: free_solid_svg_icons_1.faArrowLeft })),
                            react_1.default.createElement(react_native_1.View, { style: styles_1.default.marginTen },
                                react_1.default.createElement(react_native_paper_1.Title, { style: styles_1.default.textColorBlue }, ` Tickets `)))))),
            react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionRow, styles_1.default.marginTen] },
                react_1.default.createElement(react_native_1.View, { style: [styles_1.default.alignCenterStart, styles_1.default.flexDirectionRow] },
                    react_1.default.createElement(tab_1.default, { isActive: activeTab === ticketConstants_1.DETAIL_TAB, text: "View Ticket", icon: "file-search", onPress: () => setActiveTab(ticketConstants_1.DETAIL_TAB) }),
                    react_1.default.createElement(tab_1.default, { isActive: activeTab === ticketConstants_1.UPDATE_TAB, text: "Update Ticket", icon: "file-document-edit", onPress: handleTicketUpdate }))),
            react_1.default.createElement(react_native_1.View, null, content))));
};
exports.default = TicketDetails;
